import type { CheckItem } from "../api/types";

/** Pass/fail rule results with the fix beside each failure. The same checks the server enforces. */
export function Checks({ checks }: { checks: CheckItem[] }) {
  if (!checks.length) return null;
  return (
    <ul className="m-0 mt-3 flex list-none flex-col gap-1.5 p-0">
      {checks.map((check) => (
        <li key={check.label} className="flex items-start gap-2 text-[13.5px]">
          <span
            aria-hidden="true"
            className={`mt-px inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[12px] font-bold text-white ${
              check.pass ? "bg-positive" : "bg-negative"
            }`}
          >
            {check.pass ? "✓" : "×"}
          </span>
          <span>
            <span className="sr-only">{check.pass ? "Passed: " : "Not yet: "}</span>
            <b className="font-semibold">{check.label}</b>
            {check.pass ? null : <span className="text-text-muted">: {check.fail}</span>}
          </span>
        </li>
      ))}
    </ul>
  );
}
